import types from "./types";
import login from "@/api/auth/login";
import user from "@/api/auth/user";
import jwt from "jwt-decode";
import Cookies from "js-cookie";

const debug = process.env.NODE_ENV === "development";

export default {
  [types.AUTH_CHECK]: function({ dispatch }) {
    const userToken = Cookies.get("jwt");

    if (!userToken) {
      dispatch(types.AUTH_UNSET);
      return;
    }

    const user = localStorage.getItem("user");
    if (user && userToken) {
      dispatch(types.AUTH_SET, { user, userToken });
    } else {
      dispatch(types.AUTH_UNSET);
    }
  },
  [types.AUTH_SET]: function({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = null;
        if (typeof payload === "object") {
          const { data } = await login(payload);
          token = data;
        } else if (typeof payload === "string") {
          token = payload;
        }

        const decode = jwt(token);
        // user api needs to set the cookie first
        const cookieConfig = {
          expires: new Date(decode.exp * 1000),
          sameSite: debug ? "lax" : "strict"
        };
        const cookie = Cookies.set("jwt", token, {
          ...cookieConfig,
          secure: cookieConfig.sameSite === "strict"
        });

        if (!cookie) throw new Error("Unable to set cookie.");

        const { data: userData } = await user(`Bearer ${token}`);
        localStorage.setItem("user", JSON.stringify(userData));
        commit(types.AUTH_SET, { jwt: token, user: userData });
        resolve(userData);
      } catch (error) {
        reject(error);
      }
    });
  },
  [types.AUTH_UNSET]: function({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        Cookies.remove("jwt");
        localStorage.removeItem("user");
        localStorage.removeItem("userToken");
        commit(types.AUTH_UNSET);
        commit(types.AUTH_SET_ERRORS, []);
        resolve({ code: 401, message: "Unauthorize user." });
      } catch (error) {
        reject(error);
      }
    });
  },
  [types.AUTH_SET_COOKIE]: function({ commit }, payload) {
    localStorage.setItem("user", JSON.stringify(payload));
    commit(types.AUTH_SET_COOKIE, { user: payload });
  },
  [types.AUTH_SET_ERRORS]: function({ commit }, payload) {
    commit(types.AUTH_SET_ERRORS, payload);
  }
};
